import { Component } from '@angular/core';

@Component({
  selector: 'app-cards2-examples-12',
  templateUrl: './cards2-examples-12.component.html'
})
export class Cards2Examples12Component {}
